import { AvailableBrokerageOfferingSearchResponse, OfferingWritingCompanySearchResponse } from '@lio/api-types';
import { ArrayItem } from '@utils/commonTypes';

export type AvailableBrokerageOfferingsItem = ArrayItem<AvailableBrokerageOfferingSearchResponse['items']>;
export type OfferingWritingCompanyItem = ArrayItem<OfferingWritingCompanySearchResponse['items']>;
export type writingCompanyItem = {
  id: string;
  name: string;
};
export type JurisdictionsBrokerageOfferingsItem = ArrayItem<
  AvailableBrokerageOfferingsItem['brokerageOfferingAvailability']['jurisdictions']
>;

export const writingCompanyIds = {
  admitted: 'claocf62g000094v5be5xe1fu',
  specialty: 'claocfdat000194v5cs91gbs1',
};
